export enum UserGroupEnum {
  ALL_USER = 'ALL_USER',
  PREMIUM_USER = 'PREMIUM_USER',
  NORMAL_USER = 'NORMAL_USER',
  SUPER_USER = 'SUPER_USER',
  SPECIFIC = 'SPECIFIC',
}
